<template>
  <div class="page">
    <div class="contentView">
      <div class="titleView">
        <span style="color:#E3E3E3;">DYANMICS</span>
        <img style="width:1px;height:0.2rem;background:#000;margin:0 0.2rem;">
        <span>公司动态</span>
      </div>
      <div class="headerNavi">
        <div
          v-for="item in navi"
          :key="item.code"
          :class="item.code==codeSel?'naviSel':''"
          @click="naviTouch(item.code)">
          {{item.title}}
        </div>
      </div>
      <div class="coverBg">
        <img class="coverItem pointer" 
          v-for="(item,index) in covers"
          :key="index+100"
          :src="item.img"
          @click="coverTouch(item.url)"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      codeSel: '',
      covers:[],
      navi: [{title:'公司动态',code:'trends'},{title:'品牌合作',code:'collaborate'},{title:'速绿-永不止步',code:'sulv'}],
      urls: {
        trends: [
          'https://baijiahao.baidu.com/s?id=1688934461308599047&wfr=spider&for=pc',
          'https://k.sina.com.cn/article_6627250585_18b03d19900100v0la.html?kdurlshow=1&wm=3049_0047&from=travel',
          'http://www.huawenzs.com/yw/2106/147345.html',
          'https://www.sohu.com/a/469106315_120777541',
          'http://www.china-syw.cn/shenghuo/1004874.html',
          'https://page.om.qq.com/page/OA3NcxjjFIBbSSSmRLA4zEHA0',
          'https://mbd.baidu.com/newspage/data/landingshare?preview=1&pageType=1&isBdboxFrom=1&context=%7B%22nid%22%3A%22news_9834517940030206503%22%2C%22sourceFrom%22%3A%22bjh%22%7D',
          'https://www.sohu.com/a/461093199_120925868',
          'https://t.cj.sina.com.cn/articles/view/6634340124/18b6fff1c00100tat2',
          'https://www.sohu.com/a/469315836_120533618',
          'https://page.om.qq.com/page/OYZyTAj-XdU85JmnRGi5gRhQ0',
          'https://mp.weixin.qq.com/s/IYvvgyWalVg1VMwzvoP98w',
          'https://mp.weixin.qq.com/s/TVnUPL0yHYXYX7NKLU5ABQ',
          'https://mp.weixin.qq.com/s/N4cWGuwuTfTq1ZnpeE35IA',
        ],
        collaborate: [
          'https://www.sohu.com/a/471838268_515745',
          'https://www.yidianzixun.com/article/0SyGC8eA',
          'https://www.yidianzixun.com/article/0TQSmsAc',
          'http://www.loveesport.cn/roll/60831.html',
          'https://baijiahao.baidu.com/s?id=1702050996743473997&wfr=spider&for=pc',
          'https://www.sohu.com/a/456255433_515745',
          'https://new.qq.com/omn/20210318/20210318A0CDVT00.html',
          'https://k.sina.cn/article_6507338126_183de198e00100rnvz.html?from=tech&kdurlshow=1&sinawapsharesource=newsapp&wm=3200_0024',
          'https://page.om.qq.com/page/OJ8opza9wXS6I0LdMNfQl0kw0',
          'http://www.itjike.com.cn/yule/1833647.html',
          'http://www.facenews.cn/v-1-347523.html',
          'https://page.om.qq.com/page/O4z2HHvntBhsdZAP9NosxE0g0',
          'https://www.sohu.com/a/468486381_120823941',
          'https://www.sohu.com/a/468486143_120823941',
          'https://page.om.qq.com/page/OCldHENLpJv3aA_Sy-LdSmWA0',
          'https://www.sohu.com/a/468483945_515745',
          'http://www.facenews.cn/v-1-357641.html',
          'https://xw.qq.com/cmsid/20210609A054YD00',
          'https://new.qq.com/omn/20210611/20210611A05X4B00.html',
          'http://www.kejizhoukan.com/shenghuo/1909249.html',
          'https://page.om.qq.com/page/OxcuIWEm-7CWaFNR54XZRnIA0',
          'http://www.zgkjzk.com.cn/yule/1912565.html',
          'https://www.donews.com/news/detail/4/3132008.html',
          'https://mp.weixin.qq.com/s/FgGGW89PmRNGX_2jhYmlvA',
        ],
        sulv: [
          'https://mp.weixin.qq.com/s/6REbQv1m8c56dP7xnY9SHw',
          'https://mp.weixin.qq.com/s/bIjar1x48-Z2gzEouDHoZA',
          'https://mp.weixin.qq.com/s/YPdGzzLYC4mw__LvZAn6zg',
          'https://mp.weixin.qq.com/s/90vUe2m7OZGtX8Z_k9_w2A',
          'https://mp.weixin.qq.com/s/pG28ZatlEziDM0LQl8UP7w',
          'https://mp.weixin.qq.com/s/oHpBLNDeoiXoeeBu6Axgmg',
          'https://mp.weixin.qq.com/s/I6sPW3VrcCwB1hAAzShGbw',
          'https://mp.weixin.qq.com/s/S0aPkeGXyrn36WaqMuL84w',
        ]
      }
    };
  },
  components: {},
  mounted () {
    this.naviTouch(this.$route.query.code || 'trends');
  },
  methods: {
    naviTouch(code){
      this.codeSel = code;
      this.getCovers();
    },
    coverTouch(url){
      window.open(url,"_self")
    },
    getCovers(){
      let covers = [];
      this.urls[this.codeSel].map((item,index)=>{
        covers.push({
          url: item,
          img: require(`../assets/img/${this.codeSel}_${index}.jpg`)
        })
      })
      this.covers = covers
    },
  }
}
</script>

<style lang='scss' scoped>
.page{
  width: 100%;
  font-size: 0.20rem;
}
.contentView{
  margin: 0 auto;
}
.titleView{
  font-size: 0.28rem;
  font-weight: 600;
  text-align: left;
  background: #2EB94F;
  height: 0.5rem;
  line-height: 0.5rem;
  padding-left: 0.2rem;
  margin-bottom: 0.3rem;
  color: black;
}
.headerNavi{
  display: flex;
  align-items: center;
  justify-content: center;
  div{
    margin: 0 0.1rem;
    padding: 0.1rem 0.15rem;
    border-radius: 0.1rem;
    font-weight: 600;
    color: #000;
  }
  .naviSel{
    background: #2EB94F;
    color: #fff;
  }
}
.coverBg{
  width: 100%;
  margin: 0.2rem 0;
  display: flex;
  flex-wrap: wrap;
  .coverItem{
    width: calc(50% - 0.4rem);
    margin: 0.2rem;
  }
}
</style>